module.exports = __webpack_public_path__ + "img/one.6572869d.svg";